

import { AggregateWindow, FilterPoint, Point } from "../filter/types/types"
import { getTodayDate } from "../filter/utils/dateUtils"
import { converteTimeToDay, converteTimeToString } from "./time.utils"

  
export const createList = (aggregation:AggregateWindow, filter: FilterPoint,  data: Point[] | undefined ) => {
    const listx = []
 
    const startDate = filter.startDate

    if (aggregation ==='1mo'){
      const nbMonth = nbMonthBewteenDate(new Date(filter.startDate || new Date().toISOString()), new Date(filter.stopDate || new Date().toISOString()))
      
      for (let i = 0; i <= nbMonth ; i++){
        const legend = getTodayDate({currentDate:startDate || undefined, nbMonth: i,  resetHour: true})
        listx.push(legend)

      }
    }

    if (aggregation ==='1h'){
      
      const NbHour = nbHourBewteenDate(new Date(filter.startDate || new Date().toISOString()), new Date(filter.stopDate || new Date().toISOString()))

      for (let i = 0; i < NbHour ; i++){
        const legend = getTodayDate({currentDate:startDate || undefined, nbHour: i,resetMinute: true})
        listx.push(legend)

        
 

        
      }
    }

    if (aggregation ==='1d'){

   

      const nbDay = getNbDayBeetwenDate(new Date(startDate || new Date().toISOString()), new Date(filter.stopDate || new Date().toISOString()))

      
  
      for (let i = 1; i <=  nbDay; i++){

        const legend = getTodayDate({currentDate:startDate || undefined, nbDay: i, resetMinute: true})
        listx.push(legend)
    }



    }


    const listValueF = listx.map((item) => {
      const itemFind = data?.find((itemData) => {
        const date = new Date(itemData.Time)
  
        const dateLegend = new Date(item)
 
        
        if (compareDate(date, dateLegend, aggregation as AggregateWindow)){
          return true
        }
        return false
      })
      return itemFind?.Value || 0
    })



    return {listx, listValue : listValueF }

  }
  
  

  

  
  const getNbDayBeetwenDate = (date1: Date, date2: Date) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays
  
  }
  
  const nbMonthBewteenDate = (date1: Date, date2: Date) => {
    const yearDiff = date2.getFullYear() - date1.getFullYear();
    const monthDiff = date2.getMonth() - date1.getMonth();
    return monthDiff + (12 * yearDiff);
  }
  
  const nbHourBewteenDate = (date1: Date, date2: Date) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffHours = diffTime / (1000 * 60 * 60); 
    return diffHours;
  
  }
  
  const compareDate = (date1: Date, date2: Date, aggregateWindow: AggregateWindow) => {
  
    if (aggregateWindow === '1mo'){
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth()
    }
  
    if (aggregateWindow === '1d'){
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()
    }
  
    if (aggregateWindow === '1h'){
  
      return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate() && date1.getHours() === date2.getHours()
    }
  
      return date1.getFullYear() === date2.getFullYear() 
      && date1.getMonth() === date2.getMonth() 
      && date1.getDate() === date2.getDate()
      && date1.getHours() === date2.getHours()
      && date1.getMinutes() === date2.getMinutes()
      && date1.getSeconds() === date2.getSeconds()
  }


export const converteTitle = (startDate: string, stopDate: string) => {

  
    return 'Du '+converteTimeToDay(startDate)+' au ' + converteTimeToDay(stopDate)
  }
  
  
  
  export const convertTimeType= (aggregateWindow: AggregateWindow) => {
      switch (aggregateWindow) {
          case '1mo':
              return 'mo'
          case '1h':
              return 'h'
          case '1d':
              return 'd'
          case '1y':
              return 'y'
          default:
              return 'mo'
      }
  }
  
  export const converteTimetoName = (time: string, aggregateWindow:  AggregateWindow) => {
  
    return converteTimeToString(time, convertTimeType(aggregateWindow))
  }
  